export enum ProjectStatusDetailsEnum {
    NONE,
    REQUEST_UPDATED,
    DATE_OVERDUE,
}
